// extracted by css-extract-rspack-plugin
export default {"colorIcon":"LabelIcon-module__colorIcon___MZiyC","icon":"LabelIcon-module__icon___eK1lw index__transitionColor___c1h0N"};